<ng-container [ngSwitch]="variant">
  <ui-custom-generic-link *ngSwitchCase="mobileMenuItemType.LINK" [url]="url" class="btn link-item">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </ui-custom-generic-link>

  <button *ngSwitchCase="mobileMenuItemType.BUTTON" class="btn btn-item" [ngClass]="{ 'has-children': !hideArrow }">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
